import { render } from "./IconsDemo.vue?vue&type=template&id=e9b9dd58&scoped=true"
import script from "./IconsDemo.vue?vue&type=script&lang=js"
export * from "./IconsDemo.vue?vue&type=script&lang=js"

import "./IconsDemo.vue?vue&type=style&index=0&id=e9b9dd58&lang=scss&scoped=true"

import exportComponent from "D:\\CTS_SURAJ\\Edu Katta\\Edukatta_Gov_Eticket\\ui-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9b9dd58"]])

export default __exports__